/* lua.js generated code 0.3.0 */

require("clover/config/CloverConst");

GamePropIds = table(
    [1, "kNone", GamePropsType.kNone],
    [1, "kCoin", 2],
    [1, "kEnergy", 4],
    [1, "kCash", 14],
    [1, "kEnergyInf_1Hour", 22],
    [1, "kEnergyInf_10Min", 24],
    [1, "kGachaRedpack", 30],   // Gacha活动的红包    
    // [1, "kIslandPlay", 53],
    // [1, "kIslandPlay_l", 54],
    [1, "kNewChestRedpack", 31],   // 星星抽奖红包
    [1, "kRefresh", GamePropsType.kRefresh],
    [1, "kLine", GamePropsType.kLine],
    [1, "kSwap", GamePropsType.kSwap],
    [1, "kAdd5", GamePropsType.kAdd5],
    [1, "kWrap", GamePropsType.kWrap],
    [1, "kHammer", GamePropsType.kHammer],
    [1, "kAdd5_s", GamePropsType.kAdd5_s],
    [1, "kSuperBird_b", GamePropsType.kSuperBird_b],
    [1, "kSuperBird_b_t_limited", GamePropsType.kSuperBird_b_t_limited],
    [1, "kSuperBird_b_t_unlimited", GamePropsType.kSuperBird_b_t_unlimited],
    [1, "kLine_Wrap_b", GamePropsType.kLine_Wrap_b],
    [1, "kLine_Wrap_b_t_limited", GamePropsType.kLine_Wrap_b_t_limited],
    [1, "kLine_Wrap_b_t_unlimited", GamePropsType.kLine_Wrap_b_t_unlimited],
    [1, "kFourTile_b", GamePropsType.kFourTile_b],
    [1, "kAdd3_b", GamePropsType.kAdd3_b],
    [1, "kAdd3_b_t_limited", GamePropsType.kAdd3_b_t_limited],
    [1, "kAdd3_b_t_unlimited", GamePropsType.kAdd3_b_t_unlimited],
    [1, "kRefresh_l", GamePropsType.kRefresh_l],
    [1, "kLine_l", GamePropsType.kLine_l],
    [1, "kSwap_l", GamePropsType.kSwap_l],
    [1, "kAdd5_l", GamePropsType.kAdd5_l],
    [1, "kWrap_l", GamePropsType.kWrap_l],
    [1, "kHammer_l", GamePropsType.kHammer_l],
    [1, "kEnergy1", GamePropsType.kEnergy1],
    [1, "kEnergy2", GamePropsType.kEnergy2],
    [1, "kEnergy3", GamePropsType.kEnergy3],
    [1, "kEnergyInf", GamePropsType.kEnergyInf],
    [1, "kUnlimitedenergy_10", GamePropsType.kUnlimitedenergy_10],
    [1, "kRefresh_t", GamePropsType.kRefresh_t],
    [1, "kLine_t", GamePropsType.kLine_t],
    [1, "kSwap_t", GamePropsType.kSwap_t],
    [1, "kWrap_t", GamePropsType.kWrap_t],
    [1, "kHammer_t", GamePropsType.kHammer_t],
    [1, "kHourglass", GamePropsType.kHourglass],
    [1, "kLine_i", GamePropsType.kLine_i],
    [1, "kHammer_i", GamePropsType.kHammer_i],
    [1, "kWrap_i", GamePropsType.kWrap_i],
    [1, "kEnergyAutoUseToFullOrTenInf", 48],
    [1, "kAdd3_ad", GamePropsType.kAdd3_ad],
    [1, "kLine_Wrap_ad", GamePropsType.kLine_Wrap_ad],
    [1, "kRefresh_ad", GamePropsType.kRefresh_ad],
    [1, "kComplementStar", GamePropsType.kComplementStar],
    [1, "kComplementStar2", GamePropsType.kComplementStar2],
    [1, "kAddEnergyLimit", GamePropsType.kAddEnergyLimit],//限时增加精力上限
    [1, "kNameCard", GamePropsType.kNameCard],//新名片
    [1, "kNameDiamond", GamePropsType.kNameDiamond],//新钻石标志
    [1, "kSeasideStar_double_15", GamePropsType.kSeasideStar_double_15],//海滨之星 限时双倍卡15分钟
    [1, "kSeasideStar_double_30", GamePropsType.kSeasideStar_double_30],//海滨之星 限时双倍卡30分钟
    [1, "kAdd3_infinite", GamePropsType.kAdd3_infinite],//无限+3步
    [1, "kLine_Wrap_infinite", GamePropsType.kLine_Wrap_infinite],//无限爆炸直线
    [1, "kSuperBird_infinite", GamePropsType.kSuperBird_infinite],//无限魔力鸟
    [1, "kStarDiamond", GamePropsType.kStarDiamond],//星石
    [1, "kLevelCollect_double_15", GamePropsType.kLevelCollect_double_15],// 主线收集 限时双倍卡15分钟
    [1, "kLevelCollect_double_30", GamePropsType.kLevelCollect_double_30],// 主线收集 限时双倍卡30分钟
    [1, "kCircusGameTicket", GamePropsType.kCircusGameTicket],// 马戏团活动门票
    [1, "kAdd3_limited", GamePropsType.kAdd3_limited],//关前限时限次加三步（限时48小时）
    [1, "kLine_Wrap_limited", GamePropsType.kLine_Wrap_limited],//关前限时限次直线和爆炸熊（限时48小时）
    [1, "kSuperBird_limited", GamePropsType.kSuperBird_limited],//关前限时限次神奇鸟（限时48小时）
    [1, "kSalvageGiftAdd5", GamePropsType.kSalvageGiftAdd5]// 救援礼包加五步权益

)
GamePropPreGame = table(
    [0, GamePropIds.kAdd3_b],
    [0, GamePropIds.kLine_Wrap_b],
    [0, GamePropIds.kSuperBird_b]
)
GamePropPreGameCoin = table([0, GamePropIds.kLine_Wrap_b], [0, GamePropIds.kAdd3_b])
GamePropTypeConst = 10000
GamePropTypes = table(
    [1, "kSpecial", 0],
    [1, "kIntoBag", 1],
    [1, "kPackage", 2],
    [1, "kLevelArea", 4],
    [1, "kHideLevel", 6],
    [1, "kLevelBind", 7],
    [1, "kDress", 9]
)
GameDressTypes = table(
    [1, "kHeadFrame", 2],
    [1, "kNameEffect", 5],
)
GamePropNamesForDC = table()
GamePropNamesForDC.propNameNone = getText("clover.text.5")
GamePropNamesForDC.getPropName = function (propID) {
    propID = tostring(propID) || ""
    return getText("prop.name." + propID) || GamePropNamesForDC.propNameNone
}
